import React, {useEffect, useState} from 'react';
import {QuestionDialog, createDialog, Message} from 'coaz-ui';
import client from '../client';
import SubmitButton from './SubmitButton';
import PayMobile from './PayMobile';

const Login = () => {
    const [usernameOrIdNumberOrUserCode,setUsernameOrIdNumberOrUserCode] = useState("");
    const [password,setPassword] = useState(""); 
    const [message,setMessage] = useState({content:'',success:false});
    const [loading,setLoading] = useState(true);
    const {request,errorMessage} = client;


    const params = new URLSearchParams(window.location.search);
    
    const onLogin = async (e) => {
        e.preventDefault();
		setLoading(true);
		try {
			await request("POST",'login',{login: usernameOrIdNumberOrUserCode,password: password});
			
			window.location.href = params.get('successUrl')?params.get('successUrl'):"/_profile";
		}
		catch (error) {
			if (error.response && error.response.data) {
				if (
					error.response.data.status === "PENDING_PAYMENT" &&
					error.response.data.user &&
					error.response.data.user.userType
				) {
					createDialog({
						title:"Mobile Payment",
						Component:PayMobile,
						params:{
							userId:error.response.data.user.ref.id,
							tariffable:error.response.data.user.userType,
							rootValueReference:error.response.data.user.ref.value
						}
					})
				} else if (
					error.response.data.status === "OTP" &&
					error.response.data.user
				) {
					window.location.href = `/_change_password?username=${encodeURIComponent(error.response.data.user.name)}`;
				} else if (
					error.response.data.status ===
						"INCOMPLETE_REGISTRATION" &&
					error.response.data.user
				) {
					window.location.href = `/_finish_registration?userId=${error.response.data.user.ref.id}`;
				} else if (
					error.response.data["error_message"] && 
					error.response.data["error_message"] === "Bad credentials"
				) {
					setMessage({content:"Incorrect username or password!",success:false})
				} else {
					setMessage({content:errorMessage(error),success:false})
				}
			} else {
				setMessage({content:errorMessage(error),success:false})
			}
		}
		finally {
			setLoading(false);
		}
    }; 

    const onForgotPassword = async () => {
        setLoading(true);
        setMessage({content:'',success:false});
        try {
            await request('PUT','users/forgot-password',null,{
                usernameOrIdNumberOrUserCode:usernameOrIdNumberOrUserCode
            });
            setMessage({content:'Password successfully reset. Check your email for the OTP.',success:true});
            return {success:true};
        } catch (error) {
            const content = errorMessage(error);
            setMessage({content,success:false});
            return {success:false,message:content};
        } finally {
            setLoading(false);
        }
    };

	useEffect(() => {
		setLoading(false);
	},[])

  return (
    <div className='flex justify-center items-center w-full h-full overflow-hidden'>
        <div style={{backdropFilter:'blur(20px)'}} 
            className='flex flex-col w-11/12 sm:w-[640px] items-center rounded-2xl bg-[rgba(255,255,255,.5)] shadow-2xl'>
            <img src='/logo.png' alt='Logo' className='w-32 h-32 m-4'/>
            <div className='flex flex-row space-x-2 text-2xl'>
                <p className='font-bold  text-[rgb(0,175,240)]'>COAZ</p>
                <p className='font-light'>LOGIN</p>
            </div>
            <div onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        onLogin(e);
                    }
                }} 
                className='flex flex-col w-[95%] max-w-[384px] p-4 space-y-4'>
                <input
                    type="text"
                    id="usernameOrIdNumberOrUserCode"
                    name="usernameOrIdNumberOrUserCode"
                    value={usernameOrIdNumberOrUserCode}
                    placeholder='Username/COAZ Number/Id Number'
                    onChange={e => setUsernameOrIdNumberOrUserCode(e.target.value)}
                    className='flex w-full h-10 shrink-0 p-2 focus:outline-none text-sm font-light whitespace-nowrap bg-white rounded-lg shadow-md'
                />
                <input
                    type="password"
                    id="password"
                    name="password"
                    value={password}
                    placeholder="Password"
                    onChange={e => setPassword(e.target.value)}
                    className='flex w-full h-10 shrink-0 p-2 focus:outline-none text-sm font-light whitespace-nowrap bg-white rounded-lg shadow-md'
                />
                <button 
                    onClick={(e) => {
                       createDialog({
                            title:'Forgot Password',
                            submitText:"Yes",
                            cancelText:"No",
                            params:{
                                submit:async (e) => {
                                    return await onForgotPassword(usernameOrIdNumberOrUserCode);
                                },
                                message:'By clicking here your password will be reset and an OTP will be sent to your email. Are you sure your want to proceed?'
                            },
                            Component:QuestionDialog
                        })
                    }}
                    className='w-full h-6 items-center justify-center shrink-0  text-sm font-light italic text-[rgb(0,175,240)] hover:underline'>
                    Forgot Password?
                </button>
                <SubmitButton name='Sign in' onSubmit={onLogin} loading={loading}/>
                <div className='flex flex-row w-full justify-center font-light text-sm'>
                    <span className='text-white'>
                        Don't have an account?
                    </span>
                    &nbsp;
                    <a href='/_register' className='text-[rgb(0,175,240)] hover:underline'>
                        Sign up here
                    </a>
                </div>
                <Message message={message}/>
            </div>
        </div>
    </div>
  )
}

export default Login